import instance from './axios'

// 获取资产地图列表
export const getMapPointList = (para) => {
    return instance.post('/asset/map/list', para, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  }
// 获取管理单位列表
export const getMapCompanyList = () => {
  return instance.get('/asset/map/companyList', {}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}